module.exports = __webpack_public_path__ + "static/media/section-3-1@3x.1f047772.png";